import { TimestampType } from '@britishcouncil/common-core';
import {
  DatePickerRangeValue,
  FormDatePicker,
  FormDatePickerProps,
} from '@britishcouncil/react-admin';
import { FieldPath, FieldValues, get, useController } from 'react-hook-form';
import { RHFormFieldProps } from './types';

type RHFormDatePickerProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = RHFormFieldProps<
  FormDatePickerProps<TimestampType | DatePickerRangeValue | null>,
  TFieldValues,
  TName
>;

export const RHFormDatePicker = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  shouldUnregister,
  defaultValue,
  ...props
}: RHFormDatePickerProps<TFieldValues, TName>) => {
  const { field, formState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });

  const handleOnChange = (value: TimestampType | DatePickerRangeValue | null) => {
    field.onChange(value);
  };

  return (
    <FormDatePicker
      name={name}
      {...props}
      value={field.value}
      onChange={handleOnChange}
      onBlur={field.onBlur}
      touched
      error={get(formState.errors, name)?.message}
    />
  );
};
